import { useState } from 'react';

import FileSaver from 'file-saver';

import { RequestStatus } from 'types/RequestStatus';

import { extractFileNameFromContentDispositionOrError } from '../../utils/requestUtils';
import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

type ImportFunction = (file: Blob) => void;

/**
 * Hook to import DNID updates.
 */
export function useImportAlienationContournement(): [
  ImportFunction,
  RequestStatus | undefined,
] {
  const adminControllerApi = useApi().AdminFonctionnelControllerApi;
  const behaviourOnError = useHandleBackErrors();
  const [status, setStatus] = useState<RequestStatus>();

  return [
    async (file: Blob) => {
      setStatus(RequestStatus.PENDING);
      await adminControllerApi
        .contournementCsvImportUsingPOST(file)
        .then((result: Response) => {
          const fileName = extractFileNameFromContentDispositionOrError(result);

          setStatus(RequestStatus.SUCCESS);
          // Create dom link to download file
          void result.blob().then((blob: Blob) => {
            FileSaver.saveAs(blob, fileName);
          });
        })
        .catch((errorResponse: Response) => {
          setStatus(RequestStatus.ERROR);
          behaviourOnError(errorResponse, true);
        });
    },
    status,
  ];
}
